module.exports = __webpack_public_path__ + "img/Live-COVER.a7d83f40.png";